export const filter = {
    inputs: [
        {
            name: 'code',
            label: 'Código',
            col: '3',
            type: 'text'
        },

        {
            name: 'valid_from',
            label: 'Válido a partir',
            col: '3',
            type: 'date'
        },

        {
            name: 'valid_until',
            label: 'Válido até',
            col: '3',
            type: 'date'
        },


    ],
    selects: [
        {
            name: 'mentoring_id',
            label: 'Mentoria',
            col: 3,
            options: [
                {
                    name: 'Todas mentorias',
                    value: ''
                }
            ]
        }
    ]
};
